import React, { createContext, useContext } from 'react';
import { toast } from 'react-toastify';

// Create the context
const ToastContext = createContext();

// Define the provider component
export const ToastProvider = ({ children }) => {
  const showToast = (message, options) => {
    toast(message, options);
  };

  const showSuccessToast = (message, options) => {
    toast.success(message, options);
  };

  const showInfoToast = (message, options) => {
    toast.info(message, options);
  };

  const showWarningToast = (message, options) => {
    toast.warning(message, options);
  };

  const showErrorToast = (message, options) => {
    toast.error(message, options);
  };

  const contextValue = {
    showToast,
    showSuccessToast,
    showInfoToast,
    showWarningToast,
    showErrorToast,
  };

  return (
    <ToastContext.Provider value={contextValue}>
      {children}
    </ToastContext.Provider>
  );
};

// Custom hook to use the toast context
export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};
